
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-carbon-950 border-t border-white/5 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 bg-neon flex items-center justify-center">
                <i className="ri-links-line text-black text-lg"></i>
              </div>
              <span className="text-white font-bold text-lg tracking-tight">AFFILIX</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-8">
              Your trusted affiliate marketing platform for maximizing revenue and tracking performance.
            </p>
            <Link
              to="/dashboard"
              className="inline-block py-3.5 px-8 bg-neon text-black text-sm font-bold hover:bg-neon/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </Link>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-neon font-bold mb-6">
              <a href="/products">Products</a>
            </h4>
            <ul className="space-y-4">
              <li><Link to="/products" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">All Products</Link></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Marketing Tools</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">SEO Tools</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Business Tools</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Creative Tools</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-neon font-bold mb-6">
              <a href="/resources">Resources</a>
            </h4>
            <ul className="space-y-4">
              <li><Link to="/resources" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">All Resources</Link></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Guides</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">Support</a></li>
              <li><a href="#" className="text-white/40 hover:text-white text-sm transition-colors cursor-pointer">API Docs</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Stay Updated</h4>
            <p className="text-white/40 text-sm mb-6">
              Get the latest affiliate marketing tips and product updates.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-neon/50 text-sm"
              />
              <button className="px-6 py-3 bg-neon text-black font-bold hover:bg-neon/90 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 text-center pointer-events-none">
          <div className="text-[180px] font-bold text-white/[0.02] leading-none select-none">
            AFFILIX
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 py-6 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2024 Affilix. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/30 hover:text-white text-xs transition-colors cursor-pointer">Privacy</a>
            <span className="text-white/10">|</span>
            <a href="#" className="text-white/30 hover:text-white text-xs transition-colors cursor-pointer">Terms</a>
            <span className="text-white/10">|</span>
            <a href="#" className="text-white/30 hover:text-white text-xs transition-colors cursor-pointer">Cookies</a>
            <span className="text-white/10">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="text-white/30 hover:text-white text-xs transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
